module.exports = __webpack_public_path__ + "static/media/paw-claws.7bfc2f8b.svg";